<template>
  <v-container>
    <v-dialog v-model="open" persistent max-width="1500px">
      <c-card class="white" title="회원 상세 정보" style="float: right">
        <v-col class="d-flex justify-end">
          <c-btn class="mx-1" color="blue" outlined @click="updateCustomerDialog = true" :disabled="isWithdrawalCustomer" iconName="mdi-pencil" >수정</c-btn>
          <c-btn class="mx-1" color="grey" outlined @click="deleteCustomerType" iconName="delete"  :disabled="isWithdrawalCustomer">삭제</c-btn>
          <c-btn class="mx-1" color="grey" outlined @click="open=false"  iconName="mdi-format-list-bulleted-square">돌아가기</c-btn>
        </v-col>

        <v-col cols="12" class="pt-0">
          <c-card title="회원 정보" class="white">
            <v-row justify="space-around" align="center">

              <div style="width: calc(100% - 250px); margin-left:30px;">
                <v-row align="center">
                  <v-col class="mt-0 pt-0 mx-0 px-0" cols="12">
                    <h3>인적사항</h3>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>이름</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text common-name" @click="customerInfo ? $router.push(`/customers/${customerInfo.id}`) : ''">{{ $func.formatCustomerName(this.customerInfo) }}</span>
                  </v-col>
                  <v-col cols="12" class="my-0 py-0"></v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>성별</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text">{{$func.gender(this.customerInfo.gender, false)}}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>생년월일</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text">{{customerInfo.birth? customerInfo.birth : '-'}}</span>
                  </v-col>
                  <v-col cols="12" class="my-0 py-0"></v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>주소</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="10">
                    <div class="black--text">{{customerInfo.address}}</div>
                    <div class="black--text" v-if="this.customerInfo.addressDetails">
                      {{customerInfo.addressDetails}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="2">
                    <span>연락처</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text">{{customerInfo.mobileNo}}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>이메일</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text">{{customerInfo.email}}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>가입일</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text">
                      {{ $func.dateToString(customerInfo.created)}}
                    </span>
                  </v-col>
                </v-row>

                <v-row align="center">
                  <v-col class="mt-5 pt-0 mx-0 px-0" cols="12">
                    <h3>회원 유형 정보</h3>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>회원 유형</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text">{{ showCustomerType(customerInfo.customerType) }}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span v-if="(customerInfo.customerType && customerInfo.customerType.configValue === 'ct_pregnant')">분만 예정일</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text">{{ customerInfo.expectedDeliveryDate === null ? '' : customerInfo.expectedDeliveryDate }}</span>
                  </v-col>

                  <template v-if="customerInfo.mobilityWeakInfo">
                    <v-col cols="12" sm="6" md="2">
                      <span>장애 유형 및 정도</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <span class="black--text" v-html="customerHandicapType"/>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <span>휠체어 유무</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <span class="black--text">{{ customerInfo.mobilityWeakInfo.wheelchair }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <span>의사소통 가능 여부</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <span class="black--text">{{ customerInfo.mobilityWeakInfo.isCommunicable ? '가능' : '불가능'}}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <span>일상생활 상태</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <span class="black--text">{{ displayLifeStatus }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <span>기초생활수급자 여부</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <span class="black--text">{{ customerInfo.mobilityWeakInfo.isBasicLivelihood ? '예' : '아니오'}}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <span>비상연락망</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <span class="black--text" v-html="familyContactList"/>
                    </v-col>
                  </template>
                </v-row>
              </div>
            </v-row>
          </c-card>

          <c-card v-if="checkCenterService" title="바우처 정보" class="white" style="margin-top: 30px">
            <v-row justify="space-around" align="center">
              <div style="width: calc(100% - 250px); margin-left:30px;">
                <v-row align="center">
                  <v-col cols="12" sm="6" md="2">
                    <span>발급 개수</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text"> {{ voucherInfo.issueVoucher }} </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>사용 개수</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text"> {{ voucherInfo.useVoucher }} </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>남은 개수</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text"> {{ voucherInfo.remainVoucher }} </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <span>반환 개수</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <span class="black--text"> {{ voucherInfo.backVoucher }} </span>
                  </v-col>
                </v-row>
              </div>
            </v-row>
          </c-card>

          <c-card title="그룹 정보" class="white" style="margin-top: 30px">
            <c-table
                hide-default-footer
                :headers="groupHeader"
                :items="groupInfo">
              <template #created="{item}">
                {{$func.dateToString(item.created)}}
              </template>
            </c-table>
          </c-card>
        </v-col>
      </c-card>
    </v-dialog>

    <customer-c-u-dialog
        :open.sync="updateCustomerDialog"
        :customerFormData="customerInfo"
        @reqUpdateCustomer="reqUpdateCustomer"
    />

  </v-container>
</template>

<script>
import CustomerCUDialog from "../../Default/Customer/CustomerCUDialog";
export default {
  components: {CustomerCUDialog},
  name: "CustomerInfoDialog",
  props:{
    updateCustomerDialog: false,
    open: {
      type: Boolean,
      default: false
    },
    customerInfo : {
      type: Array | Object
    },
    voucherInfo : {
      type: Array
    },
    groupInfo : {
      type: Array
    }
  },
  data() {
    return {
      groupHeader: [
        {
          text: '그룹명',
          value: 'groupName',
          align: 'center',
          sortable: true,
        },
        {
          text: '신청 회원',
          value: 'joiner',
          align: 'center',
          sortable: true,
        },
        {
          text: '그룹 가입일',
          value: 'created',
          align: 'center',
          sortable: true,
        },
        {
          text: '그룹 유형',
          value: 'type',
          align: 'center',
          sortable: true,
        },
        {
          text: '소속 회원 수',
          value: 'memberCnt',
          align: 'center',
          sortable: true,
        },
      ],
    }
  },
  computed: {
    customerHandicapType() {
      const handicapTypeList = [
        {text: '간', value:'간'},
        {text: '뇌전증', value:'뇌전증'},
        {text: '뇌병변', value:'뇌병변'},
        {text: '시각', value:'시각'},
        {text: '신장', value:'신장'},
        {text: '심장', value:'심장'},
        {text: '안면', value:'안면'},
        {text: '언어', value:'언어'},
        {text: '자폐성', value:'자폐성'},
        {text: '장루, 요루', value:'장루,요루'},
        {text: '정신', value:'정신'},
        {text: '지적', value:'지적'},
        {text: '지체', value:'지체'},
        {text: '청각', value:'청각'},
        {text: '호흡기', value:'호흡기'},
        {text: '일시적 장애', value:'일시적장애'},
        {text: '직접입력', value:'직접입력'}
      ];
      const handicapDegreeList = [{text: '심함', value: '심함'}, {text: '심하지 않음', value: '심하지않음'}, {text: '기타', value: '기타'}];
      let handicapInfo = this.customerInfo.mobilityWeakInfo.handicapInfo;
      try {
        if(handicapInfo) {
          handicapInfo = JSON.parse(handicapInfo);

          return handicapInfo.map(handicap => {
            let type = handicapTypeList.find(handicapType => handicapType.value === handicap.type);
            type = !type ? handicap.type : type.text
            const degree = handicapDegreeList.find(handicapDegree => handicapDegree.value === handicap.degree);
            return type && degree ? type + ' (' + degree.text + ')' : '';
          }).join('<br/>');
        }
      } catch(e) {
        console.error('fail handicapInfo parsing : ', e)
      }
      return '';
    },
    familyContactList() {
      const familyContactRelationList =
          [
            {text: '가족', value:'가족'},
            {text: '친구, 지인', value:'친구,지인'},
            {text: '복지사', value:'복지사'},
            {text: '기타', value:'기타'}
          ];
      let familyContactList = this.customerInfo.familyContactList;
      try {
        if(familyContactList) {
          familyContactList = JSON.parse(familyContactList);

          return familyContactList.map(contact => {
            let relation = familyContactRelationList.find(item => item.value === contact.relation);
            // familyContactRelationList 이외에 이전에 입력한 관계정보를 detail화면에서 표시는 해줌.
            relation = relation ? relation.text : contact.relation;
            return contact.phone + ' &nbsp ' + relation;
          }).join('<br/>');
        }
      } catch(e) {
        console.error('fail familyContactList parsing : ', e)
      }
      return '';
    },
    checkCenterService() {
      return this.$store.state.service !== '2u';
    },
    displayLifeStatus() {
      const status = this.customerInfo.mobilityWeakInfo.lifeStatus;
      switch (status) {
        case "완전도움" : return "완전 도움"
        case "부분도움" : return "부분 도움"
        case "독립" : return "독립"
      }
    },
    isWithdrawalCustomer() {
      return this.customerInfo?.customer?.state === 'Disable'
    }
  },
  methods : {
    showCustomerType(data) {
      if(data === null || data === undefined) {
        return '일반';
      }
      const customerType = data.configValue;
      const customerTypeName = data.configName;

      return customerType === 'ct_normal' || customerType === 'ct_guardian' ? customerTypeName : '교통약자 ('+ customerTypeName +')';
    },
    async reqUpdateCustomer(data) {
      try {
        const res = await this.$api.updateCustomer(data);
        this.updateCustomerDialog = false;
        this.reqGetCustomer(this.customerInfo.id);

      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqUpdateCustomer'});
      }
    },
    async reqGetCustomer(customerId) {
      try {
        const res = await this.$api.getCustomer(customerId);
        this.customerInfo = res.data;
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqGetCustomer'});
      }
    },
    deleteCustomerType() {
      this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "회원을 삭제하시겠습니까?",
            confirm: true, callBack: () => {
              this.reqDeleteCustomer();
              },
          });
    },
    async reqDeleteCustomer() {
      try {
        let customers = [];
        if (this.selectedMoffCustomer) {
          customers  = this.selectedMoffCustomer;
        }
        customers.push(this.customerInfo);
        const res = await this.$api.deleteCustomers(customers.map(customer => customer.id));
        if (res.data.length < 1) {
          this.$store.commit('alert', {open: true, msg: '예약건이 존재하는 회원은 삭제가 불가능합니다.'});
        } else {
          this.$store.commit('alert', {open: true, timeout: 3000, msg: "삭제 완료하였습니다. 3초 후 이전페이지로 이동합니다."});
          setTimeout(() => {
            this.$router.push('/customers');
          }, 3000);
        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqDeleteCustomer'});
      }
    },
  },
  watch : {
    open : {
      deep: true,
      handler(newVal) {
        this.$emit('update:open', newVal);
      }
    },
    customerInfo : {
      deep: true,
      handler(newVal) {
        this.$emit('update:customerInfo', newVal);
      }
    }
  },
}
</script>

<style scoped>
</style>
